"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInferredUserRole = fetchInferredUserRole;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = _interopRequireDefault(require("immutable"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

function getIrisApiUri() {
  return "iris-read/v1/app?hubUserField=inferredRole&portalId=" + _hubspot.default.get();
}

function fetchInferredUserRole(earlyRequesterPromise) {
  var promise = earlyRequesterPromise || _apiClient.default.get(getIrisApiUri());

  return promise.then(function (response) {
    return _immutable.default.fromJS(response);
  }).catch(function () {
    return _immutable.default.Map();
  });
}